import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 17.4C13.71 17.4 15.16 16.37 15.16 15.15C15.16 13.77 12.81 13.1 11.8 12.88C7.83 12 7 10.2 7 8.85C7 6.87 8.76 5.22 11.08 4.87V3H12.92V4.87C15.24 5.22 17 6.87 17 8.85H15.16C15.16 7.63 13.71 6.6 12 6.6C10.29 6.6 8.84 7.63 8.84 8.85C8.84 10.18 10.95 10.84 12.2 11.12C15.29 11.8 17 13.23 17 15.15C17 17.07 15.24 18.78 12.92 19.13V21H11.08V19.13C8.76 18.78 7 17.13 7 15.15H8.84C8.84 16.37 10.29 17.4 12 17.4Z" fill={ fill || 'currentColor' } />
    </svg>
);
